import { Suspense, lazy } from "react";
// components
import LoadingScreen from "../components/loading-screen";

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

// export const HomePage = Loadable(lazy(() => import("../pages/home/Home")));

// =============  @@@@ ADMIN PAGES @@@@ ============

// AUTH Login
export const LoginPage = Loadable(
  lazy(() => import("../pages/auth/LoginPage"))
);

// =============  @@@@ Dashboard PAGES @@@@ ============

// ALL Educational Institutions Page
export const ALLEducationalInstitutionsPage = Loadable(
  lazy(() =>
    import(
      "../pages/managment/educational_institution/ALLEducationalInstitutionsPage"
    )
  )
);

// Add Educational Institution Page
export const AddEducationalInstitutionPage = Loadable(
  lazy(() =>
    import(
      "../pages/managment/educational_institution/AddEducationalInstitutionPage"
    )
  )
);

// Edit Educational Institution Page
export const EditEducationalInstitutionPage = Loadable(
  lazy(() =>
    import(
      "../pages/managment/educational_institution/EditEducationalInstitutionPage"
    )
  )
);

// NewEducationalInstitutionInfoPage
export const AddImageToSchool = Loadable(
  lazy(() =>
    import("../pages/managment/educational_institution/AddImageToSchool")
  )
);

// NewEducationalInstitutionInfoPage
export const NewEducationalInstitutionInfoPage = Loadable(
  lazy(() =>
    import(
      "../pages/managment/educational_institution/NewEducationalInstitutionInfoPage"
    )
  )
);

// School Classes Page
export const SchoolClassesPage = Loadable(
  lazy(() => import("../pages/@dashboard/school-classes/SchoolClassesPage.js"))
);

// Add SubjectToClass Page
export const AddSubjectToClassPage = Loadable(
  lazy(() => import("../pages/@dashboard/school-classes/AddSubjectToClassPage"))
);

// Add New Classess Page
export const AddNewClassesPage = Loadable(
  lazy(() => import("../pages/@dashboard/school-classes/AddNewClassesPage"))
);

// Add SectionToClass Page
export const AddSectionToClassPage = Loadable(
  lazy(() => import("../pages/@dashboard/school-classes/AddSectionToClassPage"))
);

// All Subjects Page
export const AllSubjectsPage = Loadable(
  lazy(() => import("../pages/managment/subjects/AllSubjectsPage.js"))
);

// Add New Subject Page
export const AddNewSubjectPage = Loadable(
  lazy(() => import("../pages/managment/subjects/AddNewSubjectPage.js"))
);

// All School Families Page
export const SchoolFamiliesPage = Loadable(
  lazy(() => import("../pages/@dashboard/school-families/SchoolFamiliesPage"))
);

// Add New Family Page
export const AddNewFamilyPage = Loadable(
  lazy(() => import("../pages/@dashboard/school-families/AddFamilyPage"))
);

// All School Students Page
export const SchoolStudentsPage = Loadable(
  lazy(() => import("../pages/@dashboard/school-students/SchoolStudentsPage"))
);

// Add New Student Page
export const AddNewStudentPage = Loadable(
  lazy(() =>
    import("../pages/@dashboard/school-students/AddStudentsToSchoolPage")
  )
);

// Edit Exist Student Page
export const EditExistStudentPage = Loadable(
  lazy(() => import("../pages/@dashboard/school-students/EditExistStudentPage"))
);

// All ads School  Page
export const SchoolAdsPage = Loadable(
  lazy(() => import("../pages/@dashboard/school-ads/SchoolAdsPage"))
);

// Add New ADs Page
export const AddNewAdsToSchoolPage = Loadable(
  lazy(() => import("../pages/@dashboard/school-ads/AddNewAdsToSchoolPage"))
);

// All Teacher of School  Page
export const SchoolTeachersPage = Loadable(
  lazy(() => import("../pages/@dashboard/school-teachers/SchoolTeachersPage"))
);

// School Session Page
export const SchoolSessionsPage = Loadable(
  lazy(() => import("../pages/@dashboard/school-teachers/SchoolSessionsPage"))
);

// Add new Session Page
export const AddSessionsToTeacherPage = Loadable(
  lazy(() =>
    import("../pages/@dashboard/school-teachers/AddSessionsToTeacherPage")
  )
);

// Add New Teacher Page
export const AddTeacherToSchoolPage = Loadable(
  lazy(() =>
    import("../pages/@dashboard/school-teachers/AddTeacherToSchoolPage")
  )
);

// Grades of Student  Page
export const StudentsGradesPage = Loadable(
  lazy(() =>
    import(
      "../pages/@dashboard/school-students/students-grades/StudentGradesPage"
    )
  )
);

// Result of Student  Page
export const StudentResult = Loadable(
  lazy(() =>
    import("../pages/@dashboard/school-students/student-results/StudentResult")
  )
);

// Add Grade for Student
export const AddGradeForStudentPage = Loadable(
  lazy(() =>
    import(
      "../pages/@dashboard/school-students/students-grades/AddGradeForStudentPage"
    )
  )
);

// Notes of Student  Page
export const SendingNotesFromSchoolPage = Loadable(
  lazy(() =>
    import(
      "../pages/@dashboard/school-students/students-notes/SendingNotesFromSchoolPage"
    )
  )
);

// Add Note for Student
export const AddNotesForStudentPage = Loadable(
  lazy(() =>
    import(
      "../pages/@dashboard/school-students/students-notes/AddNotesForStudentPage"
    )
  )
);

// Divisions of School Page
export const SectionInfoPage = Loadable(
  lazy(() => import("../pages/@dashboard/school-divisions/SectionInfoPage"))
);

// Add TimeSlot ForDivision Page
export const AddTimeSlotForSectionPage = Loadable(
  lazy(() =>
    import("../pages/@dashboard/school-divisions/AddTimeSlotForSectionPage")
  )
);

// Divisions of School Page
export const StudentsForSectionPage = Loadable(
  lazy(() =>
    import("../pages/@dashboard/school-students/StudentsForSectionPage")
  )
);

// Receive Notes
export const ReceiveNotesFromParentPage = Loadable(
  lazy(() =>
    import(
      "../pages/@dashboard/school-students/students-notes/ReceiveNotesFromParentPage"
    )
  )
);

// school-profile
export const EducationalInstitutionProfile = Loadable(
  lazy(() =>
    import("../pages/@dashboard/school-profile/EducationalInstitutionProfile")
  )
);
// AllSecretariesPage
export const AllSecretariesPage = Loadable(
  lazy(() =>
    import("../pages/managment/educational_institution/AllSecretariesPage")
  )
);

// Add NewSecretary Page
export const AddNewSecretaryPage = Loadable(
  lazy(() =>
    import("../pages/managment/educational_institution/AddNewSecretaryPage")
  )
);

// StudentForFamilyPage
export const StudentForFamilyPage = Loadable(
  lazy(() => import("../pages/@dashboard/school-families/StudentForFamilyPage"))
);

// EditFamilyPage
export const EditFamilyPage = Loadable(
  lazy(() => import("../pages/@dashboard/school-families/EditFamilyPage"))
);

// Edit Teacher Page
export const EditTeacherPage = Loadable(
  lazy(() => import("../pages/@dashboard/school-teachers/EditTeacherPage"))
);

// All Students Page For (Management)
export const AllStudentsPage = Loadable(
  lazy(() => import("../pages/managment/students/AllStudentsPage"))
);

// EditSectionPage
export const EditSectionPage = Loadable(
  lazy(() => import("../pages/@dashboard/school-divisions/EditSectionPage"))
);

// StudentInfoPage
export const StudentInfoPage = Loadable(
  lazy(() => import("../pages/@dashboard/school-students/StudentInfoPage"))
);

// StudentPaymentInfoPage
export const StudentPaymentInfoPage = Loadable(
  lazy(() =>
    import("../pages/@dashboard/school-students/StudentPaymentInfoPage")
  )
);

// AddPaymentForStudentPage
export const AddPaymentForStudentPage = Loadable(
  lazy(() =>
    import("../pages/@dashboard/school-students/AddPaymentForStudentPage")
  )
);

// AllMinisterialDecisions
export const AllMinisterialDecisions = Loadable(
  lazy(() =>
    import("../pages/managment/ministerial_decisions/AllMinisterialDecisions")
  )
);

// AllSamples
export const AllSamples = Loadable(
  lazy(() => import("../pages/managment/samples/AllSamples"))
);

// AllSamples
export const AddNewSample = Loadable(
  lazy(() => import("../pages/managment/samples/AddNewSample"))
);

// AllQuestions
export const QuestionsOfSamples = Loadable(
  lazy(() => import("../pages/managment/samples/QuestionsOfSamples"))
);

// Add Qusetion to sample
export const AddQuestionToSample = Loadable(
  lazy(() => import("../pages/managment/samples/AddQuestionToSample"))
);

// Add Image to Question
export const AddImageToQuestion = Loadable(
  lazy(() => import("../pages/managment/samples/AddImageToQuestion"))
);
export const AddMinisterialDecisionPage = Loadable(
  lazy(() =>
    import("../pages/managment/ministerial_decisions/AddMinisterialDecisions")
  )
);

export const AddPublicAdsPage = Loadable(
  lazy(() => import("../pages/managment/ads/AddPublicAds"))
);

export const PublicAdsPage = Loadable(
  lazy(() => import("../pages/managment/ads/PublicAdsPage"))
);
